import { api } from "@/api"
import type { Ref } from "vue"
import { useQuery } from "@tanstack/vue-query"
import type { Donation } from "@/services/sharedTypes/donation"

export const retrieveDonation = async (
  donationId: string
) => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<Donation>
  >(`/donations/${donationId}/`)

  return {
    ...body,

    createdAt: DateFns.parseISO(body.createdAt),
  }
}

export const useDonation = (
  donationId: string | Ref<string>
) =>
  useQuery({
    queryKey: [
      BASE_DONATIONS_QUERY_KEY,
      donationId,
    ] as const,
    queryFn: ({ queryKey: [_, donationId_] }) =>
      retrieveDonation(donationId_),
    refetchInterval: 60 * 1000,
    staleTime: 60 * 1000,
  })
